/* React */
import React, { useEffect } from "react";

/* React Router */
import {
  Redirect,
  Route,
  useRouteMatch,
} from "react-router";

/* Ionic */
import { IonRouterOutlet } from "@ionic/react";
import { setMenuType } from "src/redux/features/menu/secondary-menu/secondaryMenuSlice";

/* React Redux */
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/redux/store";

/* Utils */
import PageWrapper from "src/utils/wrapper/page-wrapper/PageWrapper";
import AdminDashboardWrapper from "src/utils/wrapper/admin-dashboard-wrapper/AdminDashboardWrapper";
import AdminRoute from "src/utils/routes/admin-route/AdminRoute";

/* Pages */
import DataHandler from "src/pages/admin-dashboard/data-handler/DataHandler";
import FeatureSelection from "src/pages/admin-dashboard/feature-selection/FeatureSelection";
import Settings from "src/pages/admin-dashboard/settings/Settings";

/* Components */
import LoadingScreen from "src/components/shared/loading-screen/LoadingScreen";
import SecondaryMenuWrapper from "src/utils/wrapper/secondary-menu-wrapper/SecondaryMenuWrapper";

/* Constants */
import {
  MenuContentType,
  MenuType,
} from "src/shared/constants/menu/Menu";

const AdminDashboard: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const path = useRouteMatch();

  const secondaryMenuState = useSelector(
    (state: RootState) => state.secondaryMenu
  );

  const { menuType } = secondaryMenuState;

  useEffect(() => {
    /**
     * 'menuType' is set to 'MenuType.ADMIN_DASHBOARD'.
     * To ensure a consistent behavior, check if
     * 'menuType' is not the current menu before dispatching it.
     *
     * 'path' is required in dependency array.
     */

    if (menuType !== MenuType.ADMIN_DASHBOARD) {
      dispatch(setMenuType(MenuType.ADMIN_DASHBOARD));
    }
  }, [dispatch, path, menuType]);

  return (
    <PageWrapper>
      <LoadingScreen />
      <SecondaryMenuWrapper
        menuId={menuType}
        scssProps={{ padding: "0px", width: "332px" }}
      />
      <IonRouterOutlet id={MenuContentType.ADMIN_DASHBOARD}>
        <AdminDashboardWrapper>
          <AdminRoute
            exact={true}
            path={`${path.path}/data-handler`}
            component={DataHandler}
          />
          <AdminRoute
            exact={true}
            path={`${path.path}/feature-selection`}
            component={FeatureSelection}
          />
          <AdminRoute
            exact={true}
            path={`${path.path}/settings`}
            component={Settings}
          />
          <Route exact path={`${path.path}`}>
            <Redirect to={`${path.path}/data-handler`} />
          </Route>
        </AdminDashboardWrapper>
      </IonRouterOutlet>
    </PageWrapper>
  );
};

export default AdminDashboard;
